import { useBreakpointValue } from '@chakra-ui/react'

export const useResponsive = <T>(sp: T, pc: T) => {
  const result = useBreakpointValue({ base: sp, sm: pc })
  return result
}
